import appmaker from '@appmaker/core/index';
import { DeviceMobileIcon } from '@heroicons/react/solid';
import Home from './routes/Home';
import ThemePreview from './routes/ThemePreview';
import { registerCustomThemes } from './custom-theme-blocks';
import ThemeDetailRoute from './routes/ThemeDetailRoute';

const Plugin = {
	id: '@appmaker/themes',
	name: 'Themes',
	activate: () => {
		appmaker.registerRoute({
			routeName: '/themes/:handle/:route',
			component: ThemeDetailRoute,
		});
		appmaker.registerRoute({
			routeName: '/themes/:handle',
			component: ThemePreview,
		});
		appmaker.registerRoute({
			routeName: '/themes',
			component: Home,
		});
		/**
		 * Menu Items
		 */
		// Menu item now registered in sidebar-groups package

		/**
		 * Register theme based blocks
		 */
		registerCustomThemes();
	},
};

export default Plugin;
